document.addEventListener('click', async (e) => {
  const btn = e.target.closest('.zk-add-btn');
  if (!btn) return;

  e.preventDefault();
  const id = btn.getAttribute('data-product-id');
  if (!id) return;

  try {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id, quantity: 1 })
    });

    // Abre el mini carrito lateral
    const cartRoot = document.querySelector('#zk-cart-root');
    if (cartRoot) {
      cartRoot.classList.add('is-active');
      document.body.classList.add('zk-cart-open');
    }
  } catch (err) {
    console.error('Error al agregar al carrito:', err);
  }
});
